module.exports = "/packs/images/svg/facilities/healthwise~82397d71f6b9649f3b92f2397fdd24a8.svg";